export default {
	navbar: {
		login: 'ورود',
		home: 'صفحه اصلی',
		register: 'ثبت‌نام',
		industryTemplate: 'قالب‌های صنعتی',
		cloudTemplate: 'قالب‌های ابری',
		cloudData: 'داده‌های ابری',
		printSetting: 'تنظیمات چاپ',
		moreSetting: 'تنظیمات بیشتر',
		user: 'مرکز کاربری',
		unit: 'واحد',
		logout: 'خروج از حساب',
		error404: 'خطای 404',
		renamePassword: 'تغییر رمز عبور',
		editLabel: 'ویرایش برچسب',
		member: 'مرکز اعضا',
		suggest: 'بازخورد',
		download: 'مرکز دانلود',
		help: 'مرکز راهنما',
		bind: 'اتصال حساب',
		onlineTool: 'ابزارهای کاربردی',
		expansion: 'افزایش فضای ابری',
		pdfPrint: 'چاپ سند',
		sharingTemplates: 'قالب‌های اشتراکی',
		printRecord: 'سوابق چاپ',
		dataRecovery: 'بازیابی داده‌ها',
		myPrinter: 'پرینترهای من',
		cloudService: 'سرویس ابری'
	},

	button: {
		login: 'ورود',
		register: 'ثبت‌نام',
		getCode: 'ارسال',
		print: 'چاپ فوری',
		editLabel: 'ویرایش برچسب',
		copyLabel: 'کپی برچسب',
		rename: 'تغییر نام',
		delete: 'حذف',
		createLabel: 'ایجاد برچسب جدید',
		move: 'انتقال',
		createFile: 'ایجاد پوشه',
		upload: 'بارگذاری',
		cancel: 'لغو',
		confirm: 'تأیید',
		save: 'ذخیره',
		create: 'ایجاد',
		saveToCloudTem: 'ذخیره در قالب ابری',
		download: 'دانلود',
		updateAvatar: 'تغییر تصویر پروفایل',
		forgetPass: 'فراموشی رمز عبور',
		set: 'تنظیمات',
		goRegister: 'ثبت‌نام فوری',
		goLogin: 'ورود فوری',
		backLogin: 'بازگشت به ورود',
		reset: 'بازنشانی',
		useEmail: 'ثبت‌نام با ایمیل',
		usePhone: 'ثبت‌نام با شماره موبایل',
		labelset: 'تنظیمات برچسب',
		printLabel: 'چاپ',
		exitEdit: 'خروج از ویرایش',
		choose: 'انتخاب',
		help: 'مرکز راهنما',
		downloadPC: 'دانلود نسخه کلاینت',
		Renewal: 'تمدید',
		Upgrade: 'ارتقا و بهره‌مندی از مزایای ویژه',
		bingLogin: 'اتصال و ورود',
		upgradeMember: 'هم‌اکنون ارتقا دهید',
		exchange: 'کد兑换',
		exchangeNow: 'هم‌اکنون兑换 کنید',
		expansion: 'افزایش فضا',
		abandon: 'انصراف',
		logout: 'حذف حساب',
		IconicLiteracy: 'ایجاد از تصویر',
		保存到云端: 'ذخیره در فضای ابری',
		保存为PNG: 'ذخیره به‌صورت PNG',
		保存为JPEG: 'ذخیره به‌صورت JPEG',
		保存为PDF: 'ذخیره به‌صورت PDF',
		游客: 'مهمان'
	},

	lang: {
		chinese: 'چینی ساده‌شده',
		english: 'انگلیسی',
		portuguese: 'پرتغالی',
		Spanish: 'اسپانیایی',
		Russian: 'روسی',
		Persian: 'فارسی'
	},

	tips: {
		tip1: 'ورود با موفقیت انجام شد',
		tip2: 'آیا مطمئن هستید که می‌خواهید پوشه و تمام داده‌های داخل آن را حذف کنید؟',
		tip3: 'آیا مطمئن هستید که می‌خواهید این داده را حذف کنید؟',
		tip4: 'آیا مطمئن هستید که می‌خواهید این برچسب را حذف کنید؟',
		tip5: 'لطفاً نام/اندازه برچسب را وارد کنید',
		tip6: 'لطفاً صنعت را وارد کنید',
		tip7: 'لطفاً شماره موبایل / ایمیل را وارد کنید',
		tip8: 'لطفاً کد تأیید را وارد کنید',
		tip9: 'لطفاً رمز عبور جدید را تنظیم کنید',
		tip10: 'لطفاً رمز عبور جدید را تأیید کنید',
		tip11: 'لطفاً رمز عبور را وارد کنید',
		tip12: 'لطفاً نام کاربری را وارد کنید',
		tip13: 'لطفاً شماره موبایل را وارد کنید',
		tip14: 'لطفاً رمز عبور را تنظیم کنید',
		tip15: 'لطفاً رمز عبور را تأیید کنید',
		tip16: 'لطفاً صنعت را انتخاب کنید',
		tip17: 'لطفاً ایمیل را وارد کنید',
		tip18: 'لطفاً شماره موبایل / ایمیل معتبر وارد کنید',
		tip19: 'لطفاً توافق‌نامه را تأیید کنید',
		tip20: 'لطفاً شماره موبایل صحیح وارد کنید',
		tip21: 'لطفاً ایمیل صحیح وارد کنید',
		tip22: 'رمزهای عبور وارد شده یکسان نیستند',
		tip23: 'نتیجه‌ای یافت نشد، لطفاً مورد دیگری را امتحان کنید',
		tip24: 'محتوایی وجود ندارد',
		tip25: 'همین حالا برچسب خود را ایجاد کنید',
		tip26: 'لطفاً فایل‌های با فرمت tprt، tprts را انتخاب کنید',
		tip27: 'بارگذاری ناموفق بود',
		tip28: 'حذف با موفقیت انجام شد',
		tip29: 'لطفاً فایل‌های png، jpg، jpeg، xlsx، xls، csv را انتخاب کنید',
		tip30: 'حجم فایل بیش از حد مجاز است، لطفاً فایل کوچک‌تر از',
		tip31: 'کیلوبایت بارگذاری کنید',
		tip32: 'هنوز حساب ندارید؟',
		tip33: 'قبلاً حساب دارید،',
		tip34: 'ویرایش با موفقیت انجام شد',
		tip35: 'کپی با موفقیت انجام شد',
		tip36: 'لطفاً لایه را انتخاب کنید',
		tip37: 'چسباندن با موفقیت انجام شد',
		tip38: 'بارکد نمی‌تواند شامل کاراکتر چینی باشد',
		tip39: 'لطفاً تصویر با فرمت JPG، JPEG، PNG انتخاب کنید',
		tip40: 'تصویری در فضای ابری وجود ندارد',
		tip41: 'نام نمی‌تواند خالی باشد',
		tip42: 'نام فایل نباید شامل هیچ یک از کاراکترهای زیر باشد:',
		tip43: 'نام مستعار نمی‌تواند خالی باشد',
		tip44: 'ویرایش با موفقیت انجام شد، به صفحه ورود هدایت می‌شوید',
		tip45: 'فایل موجود است، آیا می‌خواهید جایگزین شود؟',
		tip46: 'خطای شبکه!',
		tip47: 'حجم فایل زیاد است، لطفاً از نسخه PC استفاده کنید!',
		tip48: 'ویرایش با موفقیت انجام شد',
		tip49: 'ویرایش ناموفق بود',
		tip50: 'محتوای قالب نمی‌تواند خالی باشد',
		tip51: 'لطفاً فقط یک لایه انتخاب کنید',
		tip52: 'حداقل یک داده انتخاب کنید',
		tip53: 'لطفاً کلیدواژه را وارد کنید',
		tip54: 'کد تأیید با موفقیت ارسال شد',
		tip55: 'ثبت‌نام با موفقیت انجام شد',
		tip56: 'اضافه شد',
		tip57: 'انتقال با موفقیت انجام شد',
		tip58: 'ذخیره با موفقیت انجام شد',
		tip59: 'ارسال با موفقیت انجام شد',
		tip60: 'لطفاً تصویری کمتر از 2 مگابایت بارگذاری کنید',
		tip61: 'محتوا نمی‌تواند خالی باشد',
		tip62: 'هیچ داده‌ای در این پوشه بارگذاری نشده است',
		tip63: 'برای امنیت حساب خود، لطفاً شماره موبایل/ایمیل خود را متصل کنید!',
		tip64: 'اتصال موفق بود!',
		tip65: 'اتصال ناموفق بود!',
		tip66: 'اتصال با موفقیت انجام شد!',
		tip67: 'تغییر نام مستعار یک مزیت ویژه اعضا است، لطفاً برای استفاده ارتقا دهید!',
		tip68: 'مجوز با موفقیت صادر شد!',
		tip69: 'اندازه فونت برچسب به درستی نمایش داده نمی‌شود، لطفاً حداقل اندازه مرورگر را تنظیم کنید!',
		tip70: 'چگونه تغییر دهیم؟',
		tip71: 'توجه',
		tip72: 'این عنصر توسط عناصر دیگر مرتبط است و نمی‌توان آن را جدا کرد!',
		tip73: 'لطفاً عددی ده‌دهی بین 0 تا 9 وارد کنید',
		tip74: 'لطفاً عدد هگزادسیمال (0~9، A~F) وارد کنید',
		tip75: 'لطفاً عدد بیست و شش‌دهی (A~Z) وارد کنید',
		tip76: 'لطفاً عدد سی و شش‌دهی (0~9، A~Z) وارد کنید',
		tip77: 'این داده توسط عناصر دیگر استفاده شده، آیا مطمئن هستید که می‌خواهید حذف کنید؟',
		tip78: 'این داده دارای ارجاعات به داده‌های دیگر است، آیا مطمئن هستید که می‌خواهید حذف کنید؟',
		tip79: 'برای ویرایش یا چاپ برچسب‌ها از مرورگر Chrome یا Microsoft Edge استفاده کنید!',
		tip80: 'فرمت کدگذاری نادرست است!',
		tip81: 'تأیید امنیتی',
		tip82: 'مشخص نیست؟ تصویر دیگری دریافت کنید',
		tip83: 'محتوای چاپ نمی‌تواند خالی باشد!',
		tip84: 'لطفاً پرینتر را انتخاب کنید',
		tip85: 'کلیک کنید',
		tip86: 'دانلود و نصب و اجرا',
		tip87: 'دستیار چاپ',
		tip88: 'اگر نصب و اجرا شده است، لطفاً اینجا کلیک کنید',
		tip89: 'اتصال',
		tip90: 'دریافت پرینتر ناموفق بود، لطفاً دوباره اتصال دهید!',
		tip91: 'ارسال با موفقیت انجام شد!',
		tip92: 'ارسال ناموفق بود، لطفاً دوباره تلاش کنید!',
		tip93: 'لطفاً دستیار چاپ را نصب و اجرا کنید!',
		tip94: 'پرداخت موفق بود',
		tip95: 'زمان پرداخت تمام شد',
		tip96: 'لطفاً کد兑换 را وارد کنید',
		tip97: 'راهنمای استفاده',
		tip98: 'کد兑换 از طریق شرکت در فعالیت‌های رسمی 汉码 دریافت می‌شود;',
		tip99: 'فرایند兑换: اطلاعات حساب را بررسی کرده، کد را وارد کرده و روی "هم‌اکنون兑换" کلیک کنید;',
		tip100: 'اگر شما عضو هستید، مدت عضویت پس از兑换 تمدید می‌شود;',
		tip101: 'لطفاً زمان兑换 را رعایت کنید، پس از تاریخ انقضا کد معتبر نیست.',
		tip102: '兑换 با موفقیت انجام شد',
		tip103: 'خطای تجزیه قالب',
		tip104: 'ویژگی جدول فقط برای اعضا است، لطفاً ارتقا دهید!',
		tip105: 'لطفاً از مرورگر دسکتاپ استفاده کنید!',
		tip106: 'لطفاً پوشه‌ای برای حذف انتخاب کنید',
		tip107: 'داده‌ای وجود ندارد',
		tip108: 'لطفاً عنصری برای عملیات انتخاب کنید',
		tip109: 'لطفاً ابتدا عناصر قفل‌شده را باز کنید',
		tip110: 'لطفاً داده‌ای انتخاب کنید',
		tip111: 'ایجاد ناموفق بود',
		tip112: 'این کنترل قفل شده است',
		tip113: 'لطفاً تصویر انتخاب کنید',
		tip114: 'لطفاً مدل دستگاه را انتخاب کنید',
		tip115: 'آیا مطمئن هستید که می‌خواهید پوشه انتخاب‌شده و تمام داده‌های داخل آن را حذف کنید؟',
		tip116: 'حداقل یک پوشه لازم است!',
		tip117: 'آیا محتوای ویرایش شده فعلی ذخیره شود؟',
		tip118: 'برش هوشمند برچسب فقط برای اعضا است، لطفاً ارتقا دهید!',
		tip119: 'برش سفارشی فقط برای اعضا است، لطفاً ارتقا دهید!',
		tip120: 'خروج با موفقیت انجام شد!',
		tip121: 'خروج داده‌ها را پاک می‌کند، لطفاً با احتیاط اقدام کنید! برای استفاده مجدد باید حساب جدید ثبت کنید.',
		tip122: 'کنترل قفل شد',
		tip123: 'کنترل باز شد',
		tip124: 'لطفاً متن وارد کنید',
		tip125: 'این فونت فقط برای اعضا است، لطفاً ارتقا دهید!',
		tip126: 'بارگذاری فونت ناموفق بود',
		tip127: 'بارگذاری فایل قالب ناموفق بود',
		tip128: 'بارگذاری قالب ناموفق بود',
		tip129: 'لطفاً بارکد را کشش دهید!',
		tip130: 'درخواست بیش از حد است، لطفاً یک دقیقه بعد تلاش کنید',
		tip131: 'نسخه 汉信码 بیش از 30 است، نمایش متن پشتیبانی نمی‌شود',
		tip132: 'شبکه متصل نیست، لطفاً ابتدا اتصال دهید!',
		tip133: 'لطفاً ابتدا قابلیت سوابق چاپ را فعال کنید',
		tip134: 'لطفاً سری را انتخاب کنید',
		tip135: 'لطفاً مدل دستگاه را انتخاب کنید',
		tip136: 'حداکثر 10 اندازه رایج اضافه کنید',
		tip137: 'حداقل یک اندازه رایج باید باقی بماند',
		tip138: 'ایجاد از تصویر فقط برای اعضا است، لطفاً ارتقا دهید',
		tip139: 'لطفاً ابتدا فایل را بارگذاری کنید',
		tip140: 'لطفاً قالب انتخاب کنید',
		tip141: 'لطفاً عرض وارد کنید',
		tip142: 'لطفاً ارتفاع وارد کنید'
	},

	label: {
		label1: 'پوشه',
		label2: 'برچسب‌های اخیراً استفاده‌شده',
		label3: 'نام',
		label4: 'ویرایش نام پوشه',
		label5: 'ویرایش نام فایل',
		label6: 'ویرایش نام برچسب',
		label7: 'تغییر نام مستعار',
		label8: 'ویرایش نام مستعار',
		label9: 'تغییر رمز عبور',
		label10: 'نام مستعار',
		label11: 'حساب',
		label12: 'رمز عبور',
		label13: 'صنعت',
		label14: 'انتخاب صنعت',
		label15: 'ویرایش',
		label16: 'نام برچسب',
		label17: 'ذخیره برچسب در',
		label18: 'انتقال برچسب به',
		label19: 'پیش‌نمایش چاپ',
		label20: 'اندازه برچسب',
		label21: 'نوع قالب',
		label23: 'عرض',
		label24: 'ارتفاع',
		label25: 'چند ردیف و چند ستون',
		label26: 'تعداد ستون‌ها',
		label27: 'تعداد ردیف‌ها',
		label28: 'فاصله ستون‌ها',
		label29: 'فاصله ردیف‌ها',
		label30: 'حاشیه',
		label31: 'حاشیه چپ',
		label32: 'حاشیه راست',
		label33: 'حاشیه بالا',
		label34: 'حاشیه پایین',
		label35: 'ایجاد شده توسط من',
		label36: 'نام داده',
		label37: 'تاریخ اضافه‌شدن',
		label38: 'پیش‌فرض',
		label39: 'نام A-Z',
		label40: 'نام Z-A',
		label41: 'تاریخ صعودی',
		label42: 'تاریخ نزولی',
		label43: 'اندازه کوچک به بزرگ',
		label44: 'اندازه بزرگ به کوچک',
		label45: 'ورود با حساب',
		label46: 'بازنشانی رمز عبور',
		label47: 'من موافقم و مطالعه کردم',
		label48: 'قرارداد خدمات',
		label49: 'و',
		label50: 'سیاست حفظ حریم خصوصی',
		label51: 'پوشه جدید 1',
		label52: 'عضویت برای بهره‌مندی از مزایای ویژه',
		label53: 'پرداخت با WeChat',
		label54: 'WeChat',
		label55: 'ارتقا ویژه اعضا',
		label63: 'مزایای ویژه اعضا',
		label56: 'توصیه‌شده',
		label57: '{day} روز دیگر منقضی می‌شود',
		label59: '{date} منقضی می‌شود',
		label60: 'امروز منقضی می‌شود',
		label61: 'ماه',
		label62: 'ورود با حساب ثالث',
		label64: 'پرینتر',
		label65: 'تعداد چاپ',
		label66: 'تخفیف محدود',
		label67: 'تمام پوشه‌ها',
		label68: "انتخاب‌شده <span style='color: #003591'>{ total }</span> پوشه",
		label69: 'مدیریت',
		label70: 'سال',
		label71: 'ورود با کد تأیید',
		label72: 'برچسب سفارشی',
		label73: 'ایجاد قالب جدید',
		label74: 'ایجاد برچسب جدید',
		label75: 'انتخاب مدل دستگاه',
		label76: 'اندازه‌های رایج',
		label77: 'اندازه سفارشی',
		label78: 'اضافه کردن',
		label79: 'شماره',
		label80: 'تعداد'
	},

	privilege: {
		privilege1: 'افزایش فضای ابری',
		privilege2: 'اسکن کد برای قالب',
		privilege3: 'بدون محدودیت پوشه',
		privilege4: 'چاپ با اسکن کد',
		privilege5: 'اشتراک قالب',
		privilege6: 'چاپ سریع',
		privilege7: 'قالب متغیر',
		privilege8: 'فونت اختصاصی',
		privilege9: 'قابلیت جدول',
		privilege10: 'سوابق چاپ',
		privilege11: 'تغییر نام مستعار',
		privilege12: 'مزایای هویت',
		privilege13: 'فضای ابری'
	},
	editAttr: {
		attrText1: 'ویژگی‌های کامپوننت',
		attrText2: 'منبع داده',
		attrText3: 'متن ساده',
		attrText4: 'متن پایگاه داده',
		attrText5: 'متن سریالی',
		attrText6: 'فونت',
		attrText7: 'اندازه فونت',
		attrText8: 'سبک',
		attrText9: 'چرخش',
		attrText10: 'فاصله بین حروف',
		attrText11: 'فاصله خطوط',
		attrText12: 'شکست خودکار خط',
		attrText13: 'آینه‌ای',
		attrText14: 'معکوس سیاه',
		attrText15: 'موقعیت',
		attrText16: 'تاریخ',
		attrText17: 'عدد',
		attrText18: 'نوع زمان',
		attrText19: 'زمان سیستم',
		attrText20: 'زمان مشخص',
		attrText21: 'نوع بارکد',
		attrText22: 'مکان داده',
		attrText23: 'عدم نمایش',
		attrText24: 'پایین',
		attrText25: 'ضریب بزرگ‌نمایی',
		attrText26: 'چپ‌چین',
		attrText27: 'وسط‌چین',
		attrText28: 'راست‌چین',
		attrText29: 'سطح اصلاح خطا',
		attrText30: 'افزودن تصویر محلی',
		attrText31: 'افزودن تصویر ابری',
		attrText32: 'مقیاس متناسب',
		attrText33: 'نوع خط',
		attrText34: 'ضخامت خط',
		attrText35: 'نوع داده',
		attrText36: 'لطفاً انتخاب کنید',
		attrText37: 'اتصال به پایگاه داده',
		attrText38: 'وارد کردن داده',
		attrText39: 'محتوای تدریجی',
		attrText40: 'متغیر تدریجی',
		attrText41: 'تعداد',
		attrText42: 'فرمت عدد',
		attrText43: 'فرمت تاریخ',
		attrText44: 'انتخاب زمان',
		attrText45: 'شعاع گرد',
		attrText46: 'سازگار با بوم',
		attrText47: 'لطفاً محتوا را وارد کنید',
		attrText48: 'خط مستقیم',
		attrText49: 'خط چین',
		attrText50: 'کپی',
		attrText51: 'چسباندن',
		attrText52: 'قفل کردن',
		attrText53: 'باز کردن قفل',
		attrText54: 'تراز کردن',
		attrText55: 'تراز به چپ',
		attrText56: 'تراز عمودی وسط',
		attrText57: 'تراز به راست',
		attrText58: 'تراز افقی وسط',
		attrText59: 'تراز بالا',
		attrText60: 'تراز پایین',
		attrText61: 'توزیع افقی',
		attrText62: 'توزیع عمودی',
		attrText63: 'ترتیب لایه‌ها',
		attrText64: 'انتقال به بالا',
		attrText65: 'انتقال به پایین',
		attrText66: 'حذف',
		attrText67: 'داده ابری',
		attrText68: 'داده محلی',
		attrText69: 'واگردانی',
		attrText70: 'بازگردانی',
		attrText71: 'ذخیره',
		attrText72: 'ذخیره به عنوان',
		attrText73: 'حذف',
		attrText74: 'انتقال به بالا',
		attrText75: 'انتقال به پایین',
		attrText76: 'انتقال به چپ',
		attrText77: 'انتقال به راست',
		attrText78: 'انتخاب همه',
		attrText79: 'چاپ',
		attrText80: 'بزرگ‌نمایی بوم',
		attrText81: 'کوچک‌نمایی بوم',
		attrText82: 'چند انتخابی',
		attrText83: 'چرخش ماوس به بالا',
		attrText84: 'چرخش ماوس به پایین',
		attrText85: 'کلیک چپ',
		attrText86: 'راهنمای مبتدی',
		attrText87: 'مشاهده میانبرها',
		attrText88: 'توضیحات میانبر',
		attrText89: 'سازگار با پنجره',
		attrText90: 'کوچک‌نمایی',
		attrText91: 'بزرگ‌نمایی',
		attrText92: 'نوع سریال',
		attrText93: 'ده‌دهی',
		attrText94: 'تراز کردن',
		attrText95: 'اختلاف روز',
		attrText96: 'اختلاف دقیقه',
		attrText97: 'تصویر پس‌زمینه',
		attrText98: 'داده',
		attrText99: 'چاپ تصویر پس‌زمینه',
		attrText100: 'انتخاب داده',
		attrText101: 'مقدار عنصر',
		attrText102: 'افزودن داده جدید',
		attrText103: 'هگزادسیمال',
		attrText104: 'بیست‌وشش‌دهی',
		attrText105: 'سی‌وشش‌دهی',
		attrText106: 'ارتفاع خط',
		attrText107: 'عرض ستون',
		attrText108: 'محتوا',
		attrText109: 'افزودن ردیف',
		attrText110: 'افزودن ستون',
		attrText111: 'حذف ردیف',
		attrText112: 'حذف ستون',
		attrText113: 'ادغام',
		attrText114: 'جداسازی',
		attrText115: 'فرمت زمان',
		attrText116: 'بالا',
		attrText117: 'پر کردن',
		attrText118: 'پیشوند',
		attrText119: 'پسوند',
		attrText120: 'زمان',
		attrText121: 'جهت خط',
		attrText122: 'تصویر ابری',
		attrText123: 'کاشی‌کاری',
		attrText124: 'کشیدن',
		attrText125: 'متن افقی',
		attrText126: 'متن عمودی',
		attrText127: 'متن کمانی',
		attrText128: 'بولد',
		attrText129: 'ایتالیک',
		attrText130: 'زیرخط',
		attrText131: 'خط خورده',
		attrText132: 'شبکه',
		attrText133: 'قفل بوم',
		attrText134: 'باز کردن قفل بوم',
		attrText135: 'منطقه',
		attrText136: 'چین بزرگ',
		attrText137: 'آمریکا',
		attrText138: 'انگلستان',
		attrText139: 'واحد پول',
		attrText140: 'درصد',
		attrText141: 'اعشار',
		attrText142: 'حذف صفر انتهایی',
		attrText143: 'نماد',
		attrText144: 'نمایش نام ستون',
		attrText145: 'ردیف اول به عنوان نام ستون',
		attrText146: 'نسخه',
		attrText147: 'کدگذاری'
	},
	module: {
		editText1: 'متن',
		editText2: 'زمان',
		editText3: 'بارکد خطی',
		editText4: 'کد QR',
		editText5: 'تصویر',
		editText6: 'شکل',
		editText7: 'مستطیل',
		editText8: 'مستطیل گرد',
		editText9: 'لوزی',
		editText10: 'بیضی',
		editText11: 'مثلث',
		editText12: 'مستطیل توپر',
		editText13: 'آیکون',
		editText14: 'خط مورب',
		editText15: 'خط افقی',
		editText16: 'خط عمودی',
		editText17: 'جدول'
	},
	guide: {
		guideText1: 'خوش آمدید به',
		guideText2: 'ساده و کارآمد',
		guideText3: 'کاربردی و موضوعی',
		guideText4: 'کتابخانه منابع راحت',
		guideText5: 'تبادل داده چندسکویی',
		guideText6:
			'نرم‌افزار طراحی برچسب HereLabel طراحی برچسب‌ها را به صورت WYSIWYG امکان‌پذیر می‌کند. تنها با کشیدن و رها کردن ساده می‌توانید طراحی برچسب را انجام دهید. تجربه‌ای ساده و کارآمد از طراحی برچسب را از دست ندهید!',
		guideText7: 'رد کردن',
		guideText8: 'شروع آموزش',
		guideText9: 'راهنمای عملکرد: قالب‌های صنعتی',
		guideText10: 'قالب‌های برچسب موضوعی برای صنایع مختلف مانند خرده‌فروشی، پوشاک، بارکد و غیره ارائه می‌شود.',
		guideText11: 'راهنمای عملکرد: قالب‌های ابری',
		guideText12: 'برچسب‌های شخصی به طور خودکار در ابر ذخیره می‌شوند، می‌توان پوشه ایجاد کرد و برچسب‌ها را مدیریت کرد و از آن‌ها در رایانه و موبایل استفاده کرد.',
		guideText13: 'راهنمای عملکرد: داده‌های ابری',
		guideText14: 'فایل‌هایی مانند تصاویر و جداول می‌توانند به طور دائمی در ابر ذخیره شوند و در وب، رایانه و موبایل هر زمان و هر مکان استفاده شوند.',
		guideText15: 'راهنمای عملکرد: مرکز شخصی',
		guideText16: 'با کلیک می‌توان زبان را تغییر داد، واحدها را تغییر داد یا به صفحه مرکز شخصی رفت و اطلاعات را ویرایش کرد.',
		guideText17: 'راهنمای عملکرد: ایجاد برچسب جدید',
		guideText18: 'نام، اندازه، تعداد ردیف و ستون برچسب را تنظیم کرده و شروع به ایجاد برچسب شخصی خود کنید!',
		guideText19: 'متوجه شدم',
		guideText20: 'شروع ایجاد برچسب',
		guideText21: 'خوش آمدید به صفحه ویرایش',
		guideText22: 'با چند مرحله ساده می‌توانید ویرایش برچسب را انجام دهید، بیایید با هم یاد بگیریم!',
		guideText23: 'کتابخانه عناصر',
		guideText24: 'عناصر مختلفی مانند متن، زمان، بارکد و غیره ارائه شده است. با کلیک یا کشیدن می‌توان عناصر مورد نظر را اضافه کرد.',
		guideText25: 'ادامه آموزش',
		guideText26: 'ناحیه عملکرد',
		guideText27: 'عملکردهای عناصر شامل قفل کردن، واگردانی، بازگردانی، تراز کردن، انتقال به بالا، انتقال به پایین و کپی، چسباندن، حذف است.',
		guideText28: 'همچنین می‌توانید با راست‌کلیک روی عنصر در بوم، منوی راست‌کلیک را باز کرده و عملیات را انجام دهید.',
		guideText29: 'ناحیه ویژگی‌ها',
		guideText30: 'با انتخاب یک عنصر، ناحیه ویژگی‌ها باز می‌شود و می‌توان منبع داده، سبک، اندازه، موقعیت و سایر ویژگی‌های عنصر را ویرایش کرد.',
		guideText31: 'ذخیره و چاپ',
		guideText32: 'با کلیک روی تنظیمات برچسب، می‌توانید اندازه برچسب فعلی را تغییر دهید. <br />بعد از ویرایش برچسب، می‌توانید چاپ برچسب را امتحان کنید!',
		guideText33: 'همه را یاد گرفتم',
		guideText34: 'مرحله بعد',
		guideText35:
			'نرم‌افزار طراحی برچسب HereLabel طراحی برچسب‌ها را به صورت WYSIWYG امکان‌پذیر می‌کند. تنها با کشیدن و رها کردن ساده می‌توانید طراحی برچسب را انجام دهید. تجربه‌ای ساده و کارآمد از طراحی برچسب را از دست ندهید!',
		guideText36: 'راهنمای عملکرد: چاپ سند',
		guideText37: 'پشتیبانی از فرمت‌های مختلف مانند Word، Excel، PPT، PDF و تصویر',
		guideText38: 'راهنمای عملکرد: خدمات ابری',
		guideText39: 'امکان مدیریت و ذخیره‌سازی آنلاین امن و کارآمد ارائه می‌دهد، شامل قالب‌های ابری، داده‌های ابری، پایگاه اطلاعات محصولات، قالب محصولات، قالب‌های اشتراکی، سوابق چاپ و بازیابی داده‌ها.'
	},
	suggest: {
		suggest1: 'نوع مشکل',
		suggest2: 'عملکرد ناقص',
		suggest3: 'پیشنهاد محصول',
		suggest4: 'توضیح مشکل',
		suggest5: 'لطفاً مشکلی که با آن مواجه شده‌اید را به طور کامل شرح دهید تا ما سریعاً آن را رفع کنیم!',
		suggest6: 'اطلاعات تماس',
		suggest7: 'لطفاً اطلاعات تماس خود را وارد کنید',
		suggest8: 'عکس مشکل',
		suggest9: 'ارسال',
		suggest10: 'ارسال موفق، از بازخورد شما سپاسگزاریم!',
		suggest11: 'مفید بود',
		suggest12: 'مفید نبود',
		suggest13: 'ببخشید، مشکلی رخ داده است؟',
		suggest14: 'توضیح نامشخص / قابل فهم نیست',
		suggest15: 'محتوا دقیق نیست / مربوط به موضوع نیست',
		suggest16: 'این عملکرد خوب نیست',
		suggest17: 'مشکل دیگر',
		suggest18: 'لطفاً نوع مشکل را انتخاب کنید',
		suggest19: 'از بازخورد شما سپاسگزاریم، پیشنهاد دیگری دارید؟',
		suggest20: 'لطفاً پیشنهاد خود را وارد کنید'
	},
	download: {
		download1: 'چینی',
		download2: 'انگلیسی',
		download3: 'دانلود',
		download4: 'دانلود نسخه موبایل',
		download5: 'تبادل داده چندسکویی',
		download6: 'همگام‌سازی داده‌ها به‌صورت زمان واقعی در چهار سکوی PC، وب، iOS و Android، برچسب‌ها دیگر محدود به زمان و مکان نیستند.',
		download7: 'ساده و کارآمد',
		download8: 'طراحی برچسب‌ها به صورت WYSIWYG، تنها با کشیدن و رها کردن ساده، تجربه‌ای ساده و کارآمد از طراحی برچسب را ارائه می‌دهد.',
		download9: 'کاربردی و موضوعی',
		download10:
			'برای صنایع مختلف، قالب‌های برچسب موضوعی متنوع ارائه شده است؛ مانند برچسب آدرس، برچسب متن، برچسب بارکد، برچسب حمل و نقل، برچسب خرده‌فروشی و غیره. تنها با یک کلیک می‌توانید برچسب دلخواه خود را طراحی کنید.',
		download11: 'کتابخانه منابع راحت',
		download12: 'ما می‌خواهیم منابع با کیفیت در دسترس باشند و مجموعه‌ای بزرگ از نمادهای متداول باعث می‌شود طراحی برچسب راحت‌تر و کارآمدتر شود.',
		download13: '(فقط نسخه وب پشتیبانی می‌شود)'
	},
	help: {
		help1: 'مرکز راهنمای HereLabel',
		help2: 'مشاهده همه',
		help3: 'فهرست',
		help4: 'زمان بروزرسانی',
		help5: 'نتایج جستجو'
	},
	document: {
		text1: 'باز کردن سند',
		text2: 'برای آپلود، فایل را کلیک کرده یا مستقیماً به این بخش بکشید',
		text3: 'برش خودکار',
		text4: 'برش هوشمند برچسب',
		text5: 'برش سفارشی',
		text6: 'چاپ مستقیم',
		text7: 'سند',
		text8: 'با یک کلیک فضای خالی اضافی سند را برش دهید',
		text9: 'تقسیم هوشمند برچسب',
		text10: 'برش به چند فایل برچسب',
		text11: 'تعداد ردیف‌ها',
		text12: 'تعداد ستون‌ها',
		text13: 'نمونه',
		text14: 'مثلاً تعداد ردیف*ستون = ۲*۲',
		text15: 'مرحله بعد',
		text16: 'تنظیم اندازه کاغذ',
		text17: 'سفارشی',
		text18: 'عرض',
		text19: 'ارتفاع',
		text20: 'نتیجه چاپ',
		text21: 'حالت سند',
		text22: 'حالت تصویر',
		text23: 'وضوح',
		text24: 'روش چیدمان',
		text25: 'کشیدن',
		text26: 'پر کردن',
		text27: 'با نسبت ثابت',
		text28: 'تعداد چاپ',
		text29: 'دامنه صفحات',
		text30: 'همه',
		text31: 'صفحه جاری',
		text32: 'دامنه صفحات',
		text33: 'صفحات را با ویرگول جدا کنید (مثلاً: 1-3,5)',
		text34: 'مرحله قبل',
		text35: 'برش',
		text36: 'لطفاً فایل‌های txt، pptx، ppt، pdf، doc، docx، xls، xlsx، bp، jpg، png را آپلود کنید',
		text37: 'محتوای سند خالی است',
		text38: 'دامنه صفحات وارد شده اشتباه است',
		text39: 'تجزیه ناموفق بود',
		text40: 'آیا کل سند اعمال شود؟'
	},
	expandCloud: {
		text1: 'استفاده شده',
		text2: 'فضای کل',
		text3: 'سوابق خرید',
		text4: 'خرید فضا',
		text5: 'تاریخ خرید',
		text6: 'اعتبار تا',
		text7: 'سوابق خریدی وجود ندارد',
		text8: 'پکیج افزایش فضا',
		text9: 'پکیج خریداری شده ظرف ۵ دقیقه پس از خرید فعال می‌شود؛ پس از انقضای فضای خریداری شده، بازیابی می‌شود اما فایل‌های آپلود شده حفظ خواهند شد.'
	},
	industryTemplate: {
		text1: 'انتخاب مدل دستگاه',
		text2: 'فیلتر بیشتر',
		text3: 'جستجوی محتوا',
		text4: 'شرایط فیلتر',
		text5: 'اندازه قالب',
		text6: 'انتخاب عرض قالب',
		text7: 'انتخاب ارتفاع قالب',
		text8: '{tempCount} قالب',
		text9: 'تغییر مدل دستگاه',
		text10: 'فیلتر محتوا',
		text11: 'انتخاب سری'
	},
	shareTemplates: {
		共享管理: 'مدیریت اشتراک',
		共享码: 'کد اشتراک',
		我共享的: 'اشتراک‌های من',
		共享给我: 'به من اشتراک داده شده',
		'共享模板为会员专属特权，请升级会员后使用': 'قالب‌های اشتراکی مختص اعضای ویژه است، لطفاً پس از ارتقا به VIP استفاده کنید',
		添加共享码: 'افزودن کد اشتراک',
		当前共享人数: 'تعداد افراد اشتراک فعلی',
		设置共享文件夹: 'تنظیم پوشه اشتراکی',
		全部关闭: 'همه را غیرفعال کن',
		全部开启: 'همه را فعال کن',
		'开启共享后，他人可通过您分享的共享码，打印您共享文件夹内的模板！': 'پس از فعال کردن اشتراک، دیگران می‌توانند از طریق کد اشتراک شما قالب‌های داخل پوشه اشتراکی شما را چاپ کنند!',
		分享: 'اشتراک‌گذاری',
		有效期: 'مدت اعتبار',
		'1天': '۱ روز',
		'7天': '۷ روز',
		'30天': '۳۰ روز',
		'该有效期为会员专属特权，请升级会员后使用': 'این مدت اعتبار مختص اعضای ویژه است، لطفاً پس از ارتقا به VIP استفاده کنید',
		分享码已生成并复制: 'کد اشتراک ایجاد و کپی شد',
		确定退出该shared_by_name的共享文件: 'آیا از خروج از پوشه اشتراکی {shared_by_name} مطمئن هستید؟',
		成员管理: 'مدیریت اعضا',
		已选中total个成员: '{total} عضو انتخاب شده',
		暂无成员: 'هیچ عضوی وجود ندارد',
		请选择要删除的成员: 'لطفاً عضوی برای حذف انتخاب کنید',
		请输入共享码: 'لطفاً کد اشتراک را وارد کنید',
		'关闭后好友将无法打印您的模板，是否确定关闭？': 'پس از غیرفعال کردن، دوستان شما قادر به چاپ قالب‌های شما نخواهند بود. آیا مطمئن هستید؟',
		'他人可通过您分享的共享码打印您共享文件夹内的模板！': 'دیگران می‌توانند با استفاده از کد اشتراک شما قالب‌های پوشه اشتراکی شما را چاپ کنند!',
		开启并分享: 'فعال و اشتراک‌گذاری'
	},
	printRecord: {
		打印记录: 'سوابق چاپ',
		'关闭后，打印记录将无法存储在您的个人云端': 'پس از غیرفعال کردن، سوابق چاپ در فضای ابری شخصی شما ذخیره نخواهد شد',
		打印份数: 'تعداد چاپ',
		编辑: 'ویرایش',
		是否删除打印记录: 'آیا سوابق چاپ حذف شود؟',
		'开启打印记录后，将存储你的打印记录到你个人的云端': 'پس از فعال کردن سوابق چاپ، سوابق چاپ شما در فضای ابری شخصی ذخیره می‌شود',
		'非VIP用户可存储最近7天打印记录，VIP用户用户可存储最近3个月打印记录': 'کاربران غیر VIP می‌توانند سوابق ۷ روز اخیر را ذخیره کنند، کاربران VIP می‌توانند سوابق ۳ ماه اخیر را ذخیره کنند',
		总打印份数: 'کل تعداد چاپ'
	},
	dataRecovery: {
		数据恢复: 'بازیابی داده‌ها',
		'支持恢复最近6个月删除的模板、Excel及图片！': 'پشتیبانی از بازیابی قالب‌ها، اکسل و تصاویر حذف شده در ۶ ماه اخیر!',
		还原: 'بازگردانی',
		还原模板至: 'بازگردانی قالب به',
		还原数据至: 'بازگردانی داده به',
		恢复成功: 'بازیابی با موفقیت انجام شد',
		模板: 'قالب',
		文件: 'فایل',
		图片: 'تصویر',
		'数据恢复为会员专属特权，请升级会员后使用': 'بازیابی داده‌ها ویژه اعضای VIP است، لطفاً پس از ارتقا به VIP استفاده کنید'
	},
	myPrinter: {
		云打印机: 'پرینتر ابری',
		'非4G云打印机请在汉码App上配网绑定后使用！': 'برای پرینترهای غیر ۴G ابری، لطفاً ابتدا در اپلیکیشن Hanma شبکه و اتصال دهید!',
		解绑: 'لغو اتصال',
		添加打印机: 'افزودن پرینتر',
		请输入设备序列号: 'لطفاً شماره سریال دستگاه را وارد کنید',
		该设备不支持: 'این دستگاه پشتیبانی نمی‌شود',
		解绑成功: 'لغو اتصال با موفقیت انجام شد',
		'验证码已下发，请查看打印机': 'کد تأیید ارسال شد، لطفاً پرینتر را بررسی کنید',
		绑定成功: 'اتصال با موفقیت انجام شد',
		'请输入打印机编码(IMEI号)': 'لطفاً کد پرینتر (IMEI) را وارد کنید',
		请输入打印机打印出来的验证码: 'لطفاً کد تأیید چاپ شده توسط پرینتر را وارد کنید',
		设备序列号: 'شماره سریال دستگاه',
		打印机IMEI号: 'شماره IMEI پرینتر',
		验证码: 'کد تأیید',
		暂无设备: 'هیچ دستگاهی وجود ندارد'
	},
	printLabel: {
		驱动打印: 'چاپ با درایور',
		云打印: 'چاپ ابری',
		'暂无在线设备，请开启设备或前往我的打印机页面进行添加设备':
			'هیچ دستگاه آنلاین وجود ندارد، لطفاً دستگاه را روشن کنید یا به <a style="color:#003591;cursor:pointer" href="myPrinter">صفحه پرینترهای من</a> بروید و دستگاه اضافه کنید',
		'无在线云打印设备，请选择驱动打印': 'هیچ دستگاه ابری آنلاین وجود ندارد، لطفاً چاپ با درایور را انتخاب کنید',
		下发成功: 'ارسال با موفقیت انجام شد',
		下发失败: 'ارسال ناموفق بود',
		名称: 'نام',
		尺寸: 'اندازه'
	},
	iconicLiteracy: {
		'支持pdf，png，jpg，jpeg格式': 'پشتیبانی از فرمت‌های pdf، png، jpg، jpeg',
		'请上传pdf，png，jpg，jpeg格式': 'لطفاً فرمت pdf، png، jpg، jpeg آپلود کنید',
		读取失败: 'خواندن ناموفق بود',
		'每日限时试用total次，今日剩余count/total次': 'امکان استفاده آزمایشی روزانه {total} بار، باقی‌مانده امروز <span style="color:#003591;">{count}</span>/{total}',
		'今日试用次数已用完，请明日再来体验!': 'تعداد دفعات آزمایشی امروز به پایان رسیده است، لطفاً فردا دوباره امتحان کنید!'
	},
	goodsInfo: {
		商品信息库: 'بانک اطلاعات محصول',
		商品模板: 'قالب محصول',
		数据绑定: 'اتصال داده',
		绑定成功: 'اتصال موفق بود',
		字段名: 'نام فیلد',
		'还有数据未绑定数据库字段，未绑定的数据将默认为固定数据，是否确认编辑完成？':
			'برخی داده‌ها هنوز به فیلدهای پایگاه داده متصل نشده‌اند، داده‌های بدون اتصال به صورت پیش‌فرض ثابت خواهند بود. آیا مطمئن هستید که ویرایش تمام شد؟',
		自定义字段: 'فیلد سفارشی',
		新建商品模板: 'ایجاد قالب محصول جدید',
		设为默认: 'تنظیم به عنوان پیش‌فرض',
		默认: 'پیش‌فرض',
		批量打印: 'چاپ دسته‌ای',
		新建商品: 'ایجاد محصول جدید',
		手动录入: 'ورود دستی',
		excel导入: 'وارد کردن Excel',
		清空商品数据: 'پاک کردن داده‌های محصول',
		编辑: 'ویرایش',
		已选count项数据: '{count} داده انتخاب شده',
		'默认商品模板不存在，请刷新后重试': 'قالب پیش‌فرض محصول وجود ندارد، لطفاً صفحه را تازه کنید و دوباره امتحان کنید',
		请先选择要打印的商品数据: 'لطفاً ابتدا داده‌های محصول برای چاپ را انتخاب کنید',
		操作: 'عملیات',
		请选择导入的文件: 'لطفاً فایل برای وارد کردن را انتخاب کنید',
		选择文件: 'انتخاب فایل',
		获取模板: 'دریافت قالب',
		导入excel文件格式要求: 'شرایط فرمت فایل Excel برای وارد کردن',
		'1、名称、条码必须填写，其他选填；2、商品数量条数限制为：2000条；3、列名请按如下格式及顺序填写':
			'۱. نام و بارکد باید پر شود، بقیه اختیاری؛ ۲. محدودیت تعداد محصول: ۲۰۰۰ مورد؛ ۳. نام ستون‌ها را طبق فرمت و ترتیب زیر وارد کنید',
		'请上传.xls,.xlsx格式的文件': 'لطفاً فایل با فرمت .xls یا .xlsx آپلود کنید',
		导入成功: 'وارد کردن موفق بود',
		导入失败: 'وارد کردن ناموفق بود',
		导入: 'وارد کردن',
		请选择文件夹: 'لطفاً پوشه را انتخاب کنید',
		请输入: 'لطفاً وارد کنید',
		编辑商品: 'ویرایش محصول',
		新建商品: 'ایجاد محصول جدید',
		当前商品使用字段: 'فیلدهای استفاده شده محصول فعلی',
		'1、名称、条码为必须字段': '۱. نام و بارکد فیلدهای اجباری هستند',
		'2、会员可自定义商品字段名称及新增字段': '۲. اعضای VIP می‌توانند نام فیلد محصول و فیلد جدید را سفارشی کنند',
		使用当前字段: 'استفاده از فیلدهای فعلی',
		'名称、条码为必填字段，会员可自定义商品字段名称及新增字段': 'نام و بارکد فیلدهای اجباری هستند، اعضای VIP می‌توانند نام فیلد محصول و فیلد جدید را سفارشی کنند',
		新增字段: 'افزودن فیلد',
		编辑字段: 'ویرایش فیلد',
		请输入字段名称: 'لطفاً نام فیلد را وارد کنید',
		'自定义字段为会员专属特权，请升级会员后使用': 'فیلد سفارشی ویژه اعضای VIP است، لطفاً پس از ارتقا استفاده کنید',
		请输入字符长度小于32的字段名称: 'لطفاً نام فیلد کمتر از ۳۲ کاراکتر باشد',
		'仅支持中文、英文、空格和数字组合': 'فقط از ترکیب حروف چینی، انگلیسی، فاصله و اعداد پشتیبانی می‌شود',
		'字段名称重复，请重新修改！': 'نام فیلد تکراری است، لطفاً دوباره تغییر دهید!',
		最多支持20个字段: 'حداکثر ۲۰ فیلد پشتیبانی می‌شود',
		'您确定要清空此文件夹所有数据吗？': 'آیا مطمئن هستید که می‌خواهید همه داده‌های این پوشه را پاک کنید؟',
		'删除字段后，关联的商品字段信息将会清除，是否继续？': 'پس از حذف فیلد، اطلاعات مربوط به فیلد محصول پاک خواهد شد. آیا ادامه می‌دهید؟',
		批量删除: 'حذف دسته‌ای',
		请先选择要删除的商品数据: 'لطفاً ابتدا داده‌های محصول برای حذف را انتخاب کنید',
		'您确定要删除所选中的数据吗？': 'آیا مطمئن هستید که می‌خواهید داده‌های انتخاب شده را حذف کنید؟'
	}
};


